module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', {
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "headerNav"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav d-md-down-none",
    staticStyle: {
      "padding-left": "20px",
      "float": "left",
      "height": "65px",
      "background": "#438EB9",
      "border-bottom": "0.1em solid #fffff0"
    },
    style: (_vm.ulStyle)
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "height": "35px"
    },
    style: (_vm.headlogoStyle),
    attrs: {
      "src": _vm.headlogo
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none",
    staticStyle: {
      "float": "left",
      "height": "65px",
      "background": "#438EB9",
      "padding-left": "19px",
      "border-bottom": "0.1em solid #fffff0"
    },
    style: (_vm.ulStyle1)
  }, [_c('span', {
    staticStyle: {
      "color": "#fff",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("企业大数据平台")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto",
    staticStyle: {
      "width": "220px"
    }
  }, [_c('Dropdown', {
    staticClass: "nav-item",
    staticStyle: {
      "padding-left": "40px",
      "width": "180px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/6.png",
      "alt": "o"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.username))])])]), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.Logout
    }
  }, [_c('p', {
    staticClass: "dropdown-itemp"
  }, [_c('Icon', {
    attrs: {
      "type": "power"
    }
  }), _vm._v("   退出\n                    ")], 1)])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76bc5248"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DefaultHeader.vue
// module id = 1094
// module chunks = 284